import { fireTotalLast30daysType } from 'store/typesActions/types';
import { api } from 'services/api';

export const fireTotalLast30days = (code) => async (dispatch) => {
	dispatch({ type: fireTotalLast30daysType.FIRE_TOTAL_LAST_30 });
	try {
		const res = await api.get(`/ti/${code}/total_focus_last_30_days`);
		const { data } = res || {};
		dispatch({
			type: fireTotalLast30daysType.FIRE_TOTAL_LAST_30_SUCCESS,
			payload: data
		});
		return data;
	} catch (error) {
		const { response } = error;
		if (response && response.statsu === 400) {
			const { message } = response.data;
			dispatch({
				type: fireTotalLast30daysType.FIRE_TOTAL_LAST_30_ERROR,
				payload: { errors: { message } }
			});
		} else {
			dispatch({
				type: fireTotalLast30daysType.FIRE_TOTAL_LAST_30_ERROR,
				payload: {
					errors: { message: 'Erro desconhecido. Tente novamente mais tarde' }
				}
			});
		}
	}
};
